const PageNotFound = () => {
  return (
    <main className="flex bg-white  min-h-[calc(100vh-5rem)]">
      <div className="flex-1 py-10 pl-5 pr-10">
        <div className="flex py-10 w-full justify-center">
          <p className="text-2xl text-black">Page Not Found!</p>
        </div>
      </div>
    </main>
  );
};

export default PageNotFound;
